<template>
  <div class="fullscrean">
    <div>
      <img alt="Logo Lecard" src="../../assets/logo-lecard.png" style="width: 120px">
      <div class="mt-4">
        <h5 class="mb-1 font-weight-bold">Não foi possível conectar</h5>
        <p class="mb-4" style="max-width: 500px">
          Verifique sua conexão com a internet e tente novamente.
        </p>
        <div>
          <button class="btn btn-primary px-4" @click="reload">Tentar novamente</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServerUnavailable',

  methods: {
    reload() {
      sessionStorage.removeItem('base_server');
      window.location.reload();
    }
  }
}
</script>

<style scoped>
.fullscrean {
  display: flex;
  height: 95vh;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  width: 100%;
  text-align: center;
}

@media (max-height: 630px) {
  .fullscrean {
    height: auto;
    margin-top: 132px;
  }
}
</style>
